const translation: Record<string, string> = {
  // ========== NAVBAR ==========
  "navbar.home": "Home",
  "navbar.services": "Services",
  "navbar.about": "About Us",
  "navbar.projects": "Projects",
  "navbar.contact": "Contact",
  "navbar.products": "Products",

  // ========== FOOTER ==========
  "footer.corporate": "Corporate",
  "footer.aboutUs": "About Us",
  "footer.ourTeam": "Our Team",
  "footer.careers": "Careers",
  "footer.press": "Press",
  "footer.pages": "Pages",
  "footer.homePage": "Home",
  "footer.projects": "Projects",
  "footer.contact": "Contact",
  "footer.contactInfo": "Contact",
  "footer.address": "Perpa Trade Center, Şişli / İstanbul / Türkiye",
  "footer.phone": "+90 212 220 52 56",
  "footer.email": "info@okayisu.com",
  "footer.tagline": "Your reliable solution partner for LED lighting project design and implementation.",
  "footer.rights": "© 2026 OKAYISU Lighting Ind. Domestic and Foreign Trade Ltd. Co. All rights reserved.",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfUse": "Terms of Use",
  "footer.ctaTitle": "Let's Bring Your",
  "footer.ctaAccent": "Project to Life",
  "footer.ctaSubtitle": "Contact us now for a free site survey and quotation.",
  "footer.ctaButton": "Get in Touch Now",

  // ========== GENERAL ==========
  "general.viewAll": "View All",
  "general.backToProjects": "Back to Projects",
  "general.backToList": "Back to Project List",
  "general.loading": "Loading...",
  "general.submit": "Submit",
  "general.close": "Close",
  "general.search": "Search...",
  "general.noResults": "No results matched your search.",
  "general.all": "All",
  "general.scroll": "Scroll",

  // ========== STATS ==========
  "stats.yearsExperience": "Years of Experience",
  "stats.yearsExpShort": "Years of Experience",
  "stats.completedProjects": "Completed Projects",
  "stats.countries": "Countries",
  "stats.customerSatisfaction": "Customer Satisfaction",
  "stats.countriesService": "Countries Served",

  // ========== HERO ==========
  "hero.badge": "LED Lighting Experts",
  "hero.slide1.badge": "Istanbul Finance Center",
  "hero.slide1.year": "2019",
  "hero.slide2.badge": "Vadi Istanbul Mall",
  "hero.slide2.year": "2015",
  "hero.slide3.badge": "Kayseri Kadir Has Stadium",
  "hero.slide3.year": "2018",
  "hero.slide1.title": "A Trusted Partner",
  "hero.slide1.accent": "for Corporate Clients",
  "hero.slide1.subtitle": "Reduce costs and elevate visual impact with innovative LED technology",
  "hero.slide2.title": "Maximum Efficiency",
  "hero.slide2.accent": "for Commercial Spaces",
  "hero.slide2.subtitle": "End-to-end service from design to implementation — turnkey LED projects",
  "hero.slide3.title": "The Shining Light of",
  "hero.slide3.accent": "the Field",
  "hero.slide3.subtitle": "Elevating the stadium experience with field lighting and grandstand LED applications",
  "hero.viewProjects": "Explore Our Projects",
  "hero.getQuote": "Request a Quote",

  // ========== ABOUT ==========
  "about.badge": "About Us",
  "about.heading1": "Turning Your Vision",
  "about.heading2": "Into Light",
  "about.paragraph1": "OKAYISU is an established company operating in the field of LED lighting project design and implementation. Leveraging our comprehensive expertise and specialist team, we transform our clients' visions into reality — elevating both visual aesthetics and technical efficiency to the highest standard.",
  "about.paragraph2": "Thanks to our experienced team of experts, we deliver distinctive designs and produce high-quality products and projects. Since our inception, our accomplishments in the LED lighting sector have earned us a trusted position within the industry.",
  "about.strength1": "Experienced team of engineers and designers",
  "about.strength2": "International quality standards",
  "about.strength3": "Turnkey project management",
  "about.strength4": "Energy efficiency-focused solutions",
  "about.strength5": "Robust brand and product portfolio",
  "about.workWithUs": "Work With Us",
  "about.certificates": "Certificates & Credentials",
  "about.certificatesDesc": "Our quality certifications compliant with international standards",

  // ========== SERVICES ==========
  "services.badge": "Our Services",
  "services.heading1": "Everything About Light",
  "services.heading2": "Under One Roof",
  "services.desc": "With our extensive portfolio in LED lighting, we deliver tailored solutions for corporate clients across every industry.",
  "services.moreInfo": "Learn More",
  "services.bannerTitle": "We provide free preliminary assessments for your project.",
  "services.bannerSubtitle": "Our expert team evaluates your requirements on-site and delivers the most suitable solution for you.",
  "services.viewProducts": "Explore Our Products",
  "services.svc1.title": "LED Project Design",
  "services.svc1.desc": "We craft bespoke lighting projects that achieve excellence both aesthetically and technically. Every detail is meticulously planned.",
  "services.svc2.title": "Architectural Lighting",
  "services.svc2.desc": "From building facades to interior spaces, we deliver striking lighting solutions that seamlessly integrate with architecture.",
  "services.svc3.title": "Energy Optimization",
  "services.svc3.desc": "Achieve up to 70% energy savings by converting your existing lighting systems to LED technology.",
  "services.svc4.title": "Turnkey Implementation",
  "services.svc4.desc": "Our team manages the entire process — from design through installation, testing, and maintenance. You see only the result.",
  "services.svc5.title": "Domestic & International Projects",
  "services.svc5.desc": "We execute large-scale LED lighting projects across Türkiye and on the international stage.",
  "services.svc6.title": "Technical Support & Maintenance",
  "services.svc6.desc": "Beyond project completion, we provide uninterrupted technical support and periodic maintenance services.",

  // ========== BRANDS ==========
  "brands.badge": "Brands",
  "brands.heading": "Brands We",
  "brands.headingAccent": "Work With",

  // ========== HOME PROJECTS ==========
  "homeProjects.badge": "Reference Projects",
  "homeProjects.heading1": "Selected Works",
  "homeProjects.heading2": "From Our Portfolio",
  "homeProjects.desc": "Over the years, we have successfully completed dozens of corporate LED lighting projects across Türkiye and around the world.",
  "homeProjects.viewAll": "View All Projects",
  "homeProjects.contactUs": "Contact Us About Your Project",

  // ========== CONTACT ==========
  "contact.badge": "Contact",
  "contact.heading1": "Get In Touch",
  "contact.heading2": "For Your Project",
  "contact.desc": "Receive a complimentary preliminary assessment and quotation from our expert team for your LED lighting project. We provide solutions for projects of any scale.",
  "contact.addressLabel": "Address",
  "contact.addressValue": "Perpa Trade Center Block A Floor 5 No:204, Şişli / İstanbul / Türkiye",
  "contact.phoneLabel": "Phone",
  "contact.emailLabel": "Email",
  "contact.hoursLabel": "Working Hours",
  "contact.hoursValue": "Mon–Fri: 09:00 – 18:00",
  "contact.formTitle": "Request a Free Quote",
  "contact.fullName": "Full Name *",
  "contact.fullNamePlaceholder": "Your Full Name",
  "contact.company": "Company *",
  "contact.companyPlaceholder": "Company Name",
  "contact.email": "Email *",
  "contact.emailPlaceholder": "example@company.com",
  "contact.phone": "Phone",
  "contact.phonePlaceholder": "+90 5xx xxx xx xx",
  "contact.serviceType": "Service Type",
  "contact.serviceTypePlaceholder": "Select...",
  "contact.serviceOption1": "Architectural Lighting",
  "contact.serviceOption2": "Industrial Lighting",
  "contact.serviceOption3": "Facade Lighting",
  "contact.serviceOption4": "Interior Lighting",
  "contact.serviceOption5": "Energy Conversion Project",
  "contact.message": "Your Message *",
  "contact.messagePlaceholder": "Briefly describe your project...",
  "contact.submitBtn": "Request a Quote",
  "contact.sending": "Sending...",
  "contact.successTitle": "Message Received!",
  "contact.successMsg": "Our team will get back to you as soon as possible. Thank you.",

  // ========== PROJECTS PAGE ==========
  "projects.hero.breadcrumb": "Projects",
  "projects.hero.badge": "All Projects",
  "projects.hero.heading1": "Our",
  "projects.hero.heading2": "LED Projects",
  "projects.hero.desc": "Find all of our corporate LED lighting projects completed across Türkiye and worldwide on this page.",
  "projects.grid.searchPlaceholder": "Search projects or clients...",
  "projects.grid.count": "{count} projects listed",
  "projects.grid.noResults": "No projects matched your search.",
  "projects.cta.badge": "Ready for Your Project?",
  "projects.cta.heading1": "We're Here for",
  "projects.cta.heading2": "Your Next Project",
  "projects.cta.desc": "Let's plan your LED lighting project together. Contact us for a free site survey and quotation.",
  "projects.cta.getQuote": "Request a Quote",
  "projects.cta.homePage": "Home",
  "projects.categories.Tümü": "All",
  "projects.categories.Otel & Konaklama": "Hotels & Hospitality",
  "projects.categories.Ticari & AVM": "Commercial & Retail",
  "projects.categories.Altyapı & Ulaşım": "Infrastructure & Transport",
  "projects.categories.Spor & Eğlence": "Sports & Entertainment",
  "projects.categories.Konut & Rezidans": "Residential",
  "projects.categories.Kamu & Kültürel": "Public & Cultural",
  "projects.categories.Endüstriyel & Kurumsal": "Industrial & Corporate",
  "projects.categories.Kurumsal & Ticari": "Corporate & Commercial",

  // ========== PROJECT DETAIL ==========
  "projectDetail.breadcrumb": "Projects",
  "projectDetail.backToProjects": "Back to Projects",
  "projectDetail.aboutProject": "About the Project",
  "projectDetail.projectSummary": "Project Summary",
  "projectDetail.category": "Category",
  "projectDetail.year": "Year",
  "projectDetail.client": "Client",
  "projectDetail.location": "Location",
  "projectDetail.gallery": "Project Gallery",
  "projectDetail.galleryEmpty": "Project images and videos will be added soon.",
  "projectDetail.galleryEmptyDesc": "Please check back later for detailed information.",
  "projectDetail.backToList": "Back to Project List",
  "projectDetail.contactForProject": "Contact Us About This Project",

  // ========== PRODUCTS PAGE ==========
  "products.hero.badge": "Product Catalog",
  "products.hero.heading1": "LED Lighting",
  "products.hero.heading2": "Products",
  "products.hero.desc": "Professional LED luminaires, intelligent control systems, and architectural lighting solutions — all backed by superior quality assurance.",
  "products.grid.searchPlaceholder": "Search products...",
  "products.grid.count": "{count} products listed",
  "products.grid.noResults": "No products matched your search.",
  "products.cta.badge": "Technical Support",
  "products.cta.heading1": "Not sure which product",
  "products.cta.heading2": "suits your needs?",
  "products.cta.desc": "Our expert team evaluates your project and identifies the most suitable products and solutions for you. Get free technical consultation.",
  "products.cta.talkToExpert": "Speak to an Expert",
  "products.card.detail": "Product Details",
  "products.card.requestQuote": "Request a Quote",
  "products.card.close": "Close",
  "products.card.features": "Features",
  "products.card.specs.power": "Power",
  "products.card.specs.colorTemp": "Color Temperature",
  "products.card.specs.ipRating": "IP Rating",
  "products.categories.Tümü": "All",
  "products.categories.Dış Cephe Armatürleri": "Facade Luminaires",
  "products.categories.İç Mekan LED": "Indoor LED",
  "products.categories.Endüstriyel High-Bay": "Industrial High-Bay",
  "products.categories.Mimari Aydınlatma": "Architectural Lighting",
  "products.categories.Akıllı LED Sistemler": "Smart LED Systems",
  "products.categories.Sokak & Yol LED": "Street & Road LED",

  // ========== ABOUT PAGE ==========
  "aboutPage.breadcrumbHome": "Home",
  "aboutPage.breadcrumb": "About Us",
  "aboutPage.hero.badge": "About Us",
  "aboutPage.hero.title": "In Pursuit of Light",
  "aboutPage.hero.accent": "For 22 Years",
  "aboutPage.hero.desc": "Since 2004, OKAYISU has been providing project design and implementation services in the LED lighting industry. With our experienced team and innovative vision, we rank among the leading companies in the sector.",
  "aboutPage.story.badge": "Our Story",
  "aboutPage.story.title": "A Story of Light:",
  "aboutPage.story.accent": "The OKAYISU Journey",
  "aboutPage.story.yearsBadge": "Years of Experience",
  "aboutPage.story.p1": "OKAYISU Lighting was founded in 2004 in Istanbul to operate in the field of LED lighting technologies. Since our founding, we have successfully completed hundreds of large-scale projects both domestically and internationally.",
  "aboutPage.story.p2": "With our experienced engineering and technical team, we produce bespoke solutions for projects of every scale — from hotels to shopping malls, industrial facilities to architectural structures. Our technical expertise and industry experience enable us to achieve results that exceed our clients' expectations.",
  "aboutPage.story.p3": "Today, with completed projects across more than 20 countries, international quality certifications, and a 100% customer satisfaction-driven working principle, we have established ourselves as a trusted business partner in the industry.",
  "aboutPage.mission.title": "Our Mission",
  "aboutPage.mission.p": "To add aesthetic and functional value to spaces using LED lighting technologies; to deliver energy-efficient, environmentally friendly, and sustainable lighting solutions. To lead the industry through technical excellence and an innovative design approach, maintaining the highest level of customer satisfaction in every project.",
  "aboutPage.vision.title": "Our Vision",
  "aboutPage.vision.p": "To become a globally recognized leader in the LED lighting industry, closely following technological innovations and shaping the sector. To work toward a more livable world through sustainable lighting solutions and leave a brighter environment for future generations.",
  "aboutPage.stats.badge": "By the Numbers",
  "aboutPage.stats.title": "OKAYISU",
  "aboutPage.stats.accent": "in Numbers",
  "aboutPage.values.badge": "Our Values",
  "aboutPage.values.title": "What Makes Us",
  "aboutPage.values.accent": "Who We Are",
  "aboutPage.values.v1.title": "Innovation",
  "aboutPage.values.v1.desc": "We closely follow the latest LED technologies and continuously bring innovation to our projects.",
  "aboutPage.values.v2.title": "Quality",
  "aboutPage.values.v2.desc": "With an international quality mindset, we aim for excellence in every project.",
  "aboutPage.values.v3.title": "Expert Team",
  "aboutPage.values.v3.desc": "Our experienced engineers and designers develop tailored solutions for every project.",
  "aboutPage.values.v4.title": "Sustainability",
  "aboutPage.values.v4.desc": "We contribute to the environment and economy with energy efficiency-focused solutions.",
  "aboutPage.values.v5.title": "Global Vision",
  "aboutPage.values.v5.desc": "With completed projects in more than 20 countries, we have extensive international experience.",
  "aboutPage.values.v6.title": "Reliability",
  "aboutPage.values.v6.desc": "We earn our clients' trust through transparent processes and on-time delivery.",
  "aboutPage.certificates.badge": "Our Credentials",
  "aboutPage.certificates.title": "Certificates & Credentials",
  "aboutPage.certificates.desc": "We serve with confidence, backed by our quality certifications compliant with international standards.",
  "aboutPage.cta.badge": "Ready for Your Project?",
  "aboutPage.cta.title": "We're Here for",
  "aboutPage.cta.accent": "Your Next Project",
  "aboutPage.cta.desc": "Let's plan your LED lighting project together. Contact us for a free site survey and quotation.",
  "aboutPage.cta.btn": "Request a Quote",

  // ========== CONTACT PAGE ==========
  "contactPage.breadcrumbHome": "Home",
  "contactPage.breadcrumb": "Contact",
  "contactPage.hero.badge": "Contact",
  "contactPage.hero.title": "Get in",
  "contactPage.hero.accent": "Touch With Us",
  "contactPage.hero.desc": "Receive a free preliminary assessment and quotation from our expert team for your LED lighting project. We'll get back to you as soon as possible.",
  "contactPage.info.badge": "Reach Out",
  "contactPage.info.title": "Contact",
  "contactPage.info.accent": "Information",
  "contactPage.info.desc": "You can reach us through the channels below or fill out the form to request a quote.",
};

export default translation;